// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { LabInformation } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface ChallengeInformationState {
  challengeInformation: Record<number, LabInformation>;
  isLoading: boolean;
  isInformationFetching: boolean;
  isBuying: boolean;
  isEnding: boolean;
  error?: Error;
}

const { getChallengeInformationActions, buyChallengeActions, endChallengeActions } = actionCreatorsList;

export const initialState: ChallengeInformationState = {
  challengeInformation: {},
  isLoading: false,
  isInformationFetching: false,
  isBuying: false,
  isEnding: false,
};

export default function (state = initialState, action: RootAction):ChallengeInformationState {
  let newState = state;
  switch (action.type) {
    // getChallengeInformationActions
    case getType(getChallengeInformationActions.request): {
      newState = {
        ...state,
        isInformationFetching: !action.payload.preventLoading,
        error: undefined,
      };
      break;
    }
    case getType(getChallengeInformationActions.success): {
      const { payload } = action;
      const challenge = payload.challengeInformation;
      newState = {
        ...state,
        isInformationFetching: false,
        challengeInformation: { ...state.challengeInformation, [challenge.id]: challenge },
      };
      break;
    }
    case getType(getChallengeInformationActions.failure): {
      newState = {
        ...state,
        isInformationFetching: false,
        error: action.payload.error,
      };
      break;
    }
    // buyChallengeActions
    case getType(buyChallengeActions.request): {
      newState = {
        ...state,
        isBuying: true,
      };
      break;
    }
    case getType(buyChallengeActions.success): {
      newState = {
        ...state,
        isBuying: false,
      };
      break;
    }
    case getType(buyChallengeActions.failure): {
      newState = {
        ...state,
        isBuying: false,
      };
      break;
    }
    // endChallengeActions
    case getType(endChallengeActions.request): {
      newState = {
        ...state,
        isEnding: true,
      };
      break;
    }
    case getType(endChallengeActions.success): {
      newState = {
        ...state,
        isEnding: false,
      };
      break;
    }
    case getType(endChallengeActions.failure): {
      newState = {
        ...state,
        isEnding: false,
      };
      break;
    }
  }

  if (newState !== state) {
    newState = {
      ...newState,
      isLoading: newState.isInformationFetching || newState.isBuying
    }
  }

  return newState;
}
